import { Component } from 'react';
import PropTypes from 'prop-types';
import { SIGN_IN } from 'src/common/constants/localizations/auth';
import UnderlineLink from '../../shared/link/UnderlineLink';
import Text from '../../Text';
import authLinksCss from './auth-links.module.scss';

class SignInLink extends Component {
  static propTypes = {
    authActions: PropTypes.shape({
      needsSignInDialog: PropTypes.func.isRequired,
    }),
    areColorsInverted: PropTypes.bool,
  };

  handleClick = () => {
    const { authActions } = this.props;

    authActions.needsSignInDialog();
  };

  render() {
    return (
      <UnderlineLink
        role="button"
        tabIndex="0"
        id="signInLink"
        className={authLinksCss.authLink}
        onClick={this.handleClick}
        onKeyPress={this.handleClick}
        areColorsInverted={this.props.areColorsInverted}
      >
        <Text name={SIGN_IN} />
      </UnderlineLink>
    );
  }
}

export default SignInLink;
